import { format, parseISO } from "date-fns"


export function formatNumber(num: number | string | undefined): string {
  if (num === undefined || num === null) {
    return "N/A"
  }
  return new Intl.NumberFormat().format(Number(num))
}

export function formatCurrency(value: number | string | undefined): string {
  if (value === undefined || value === null) {
    return "N/A"
  }
  const num = typeof value === "string" ? Number.parseFloat(value) : value
  if (isNaN(num)) {
    return "N/A"
  }
  return num.toLocaleString("en-US", { style: "currency", currency: "USD" })
}


export const formatDateForDisplay = (dateString: string): string => {
  try {
    const date = parseISO(dateString)
    return format(date, "yyyy-MM-dd HH:mm:ss")
  } catch (error) {
    console.error("Error formatting date:", dateString, error)
    return "Invalid Date"
  }
}

export function getChartOptions(title: string, type: "bar" | "line" = "bar") {
  return {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: title,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: "rgba(0, 0, 0, 0.05)",
        },
      },
    },
    elements: {
      line: {
        tension: 0.4, // Smooth curves for line charts
      },
    },
    animation: {
      duration: 1000, // General animation time
      easing: "easeOutQuart", // Easing function
    },
  }
}
